/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { color, pxToEm, pxToEmWithBaseline, centerAbsolutely, imageTypes, animations, mediaQuery, backgrounds, spacing, replacePXinStringWithEM } from 'utils/styles';
import { url } from 'utils/urls';



/* ++++++++++ --------------- VALIDATION SCREEN STYLES --------------- ++++++++++ */
export default {
    validationscreen: {
    	'& .validation': {
            '& .dimmer': {
                // opacity: '.5',
                // background: color.black,
                width: '100%',
                height: '100%',
                position: 'absolute',
                top: '0',
                left: '0',
                zIndex: '1'
            },
            '& .group': {
                // animation
                transform: 'translate3d(0, 200%, 0)', // pull off screen to start
                animationName: 'fadeInUp',
                animationDelay: '0s',
                animationDuration: '.2s',
                animationFillMode: 'forwards',

                display: 'table',
                borderTopLeftRadius: pxToEm(3),
                borderTopRightRadius: pxToEm(3),
                borderBottomLeftRadius: pxToEm(9.5),
                borderBottomRightRadius: pxToEm(9.5),
                background: '#df1d1d',
                height: pxToEm(106),
                width: '100%',
                maxWidth: pxToEm(412),
                padding: `0 ${spacing.sides}`,
                position: 'absolute',
                bottom: '0',
                left: '0',
                zIndex: '2',
                '& .bodycopy, .ctas': {
                    display: 'table-cell',
                    textAlign: 'left',
                    verticalAlign: 'middle'
                },
                '& .bodycopy': {
                    padding: replacePXinStringWithEM('20px 20px 20px 0'),
                    '& .logo': {
                        marginBottom: pxToEm(10)
                    },
                    '& ul': {
                        color: color.white,
                        fontSize: pxToEm(12),
                        lineHeight: pxToEm(18),
                        // marginBottom: pxToEm(0),
                        '& li': {
                            marginLeft: pxToEmWithBaseline({ value: 15, fontSizeBaseline: 12 }),
                            marginBottom: pxToEmWithBaseline({ value: 10, fontSizeBaseline: 12 })

                        }
                    }
                },
                '& .ctas': {
                    '& .button': {
                        width: pxToEmWithBaseline({ value: 88, fontSizeBaseline: 14 }),
                        color: 'rgb(23, 60, 128)',
                        fontWeight: 500
                    }
                }
            }
	    }
    }
};
